jQuery(document).ready(function ($) {
    $('[data-rest] #category').on('change', function (event) {
        var btnFilter = $('[data-rest]').find('[data-filter-send]');
        if (btnFilter) {
            btnFilter.click();
        }
    });
});
